/* eslint-disable react-hooks/exhaustive-deps */
import { React } from "react";
import { Formik } from "formik";
import { customPost, customPut } from "../../../utils/services";
import { useSelector } from "react-redux";
import Spinner from "../../../components/common/Spinner";
import Input from "../../../components/common/Input";
import Button from "../../../components/common/Button";
import Select from "../../../components/common/Select";
import toast from 'react-hot-toast';
import * as Yup from "yup";

const validaciones = Yup.object().shape({
  nombre_comercial: Yup.string().required("nombre es requerido"),
  razon_social: Yup.string().required("razon social es requerida"),
  nit: Yup.string().required("nit es requerido"),
  direccion: Yup.string().required("direccion es requerida"),
  telefono: Yup.string().required("telefono es requerido")
});

export const Form = (props) => {
  const token = useSelector((state) => state.loginReducer.data.token);

  return (
    <Formik
      initialValues={{
        nombre_comercial: props.editar ? props.value.nombre_comercial : "",
        razon_social: props.editar ? props.value.razon_social : "",
        nit: props.editar ? props.value.nit : "",
        direccion: props.editar ? props.value.direccion : "",
        telefono: props.editar ? props.value.telefono : "",
      }}
      validationSchema={validaciones}
      onSubmit={async (values, { resetForm }) => {
        if (props.editar) {
          await customPut(props.value.id, values, 'proveedores', token)
            .then(async (data) => {
              if (data?.status >= 200 && data?.status <= 210) {
                toast.success(data?.data?.msg);
                props.setEdit(false);
                props.setCrear(false);
              }
            })
            .catch(function (error) {
              if (error.response.status >= 400 && error.response.status <= 450) {
                toast.error(error.response.data.error);
              } else if (error.response.status >= 500) {
                toast.error("Error interno comuniquese con el administrador");
              }
            });
        } else {
          await customPost(values, 'proveedores', token)
            .then(async (data) => {
              if (data?.status >= 200 && data?.status <= 210) {
                toast.success(data?.data?.msg);
                props.setCrear(false);
                resetForm({});
              }
            })
            .catch(function (error) {
              if (error.response.status >= 400 && error.response.status <= 450) {
                toast.error(error.response.data.error);
              } else if (error.response.status >= 500) {
                toast.error("Error interno comuniquese con el administrador");
              }
            });
        }
      }}
    >
      {({ values, handleChange, handleSubmit, isSubmitting }) => (
        <div className="mx-5">
          <div className="mb-3">
            <Input
              type="text"
              name="nombre_comercial"
              value={values.nombre_comercial}
              onChange={handleChange}
              validacion={true}
              label="Nombre comercial"
            />
          </div>
          <div className="mb-3">
            <Input
              type="text"
              name="razon_social"
              value={values.razon_social}
              onChange={handleChange}
              validacion={true}
              label="Razon social"
            />
          </div>
          <div className="mb-3">
            <Input
              type="text"
              name="direccion"
              value={values.direccion}
              onChange={handleChange}
              validacion={true}
              label="Direccion"
            />
          </div>
          <div className="mb-3">
            <Input
              type="text"
              name="nit"
              value={values.nit}
              onChange={handleChange}
              validacion={true}
              label="Nit"
            />
          </div>
          <div className="mb-3">
            <Input
              type="text"
              name="telefono"
              value={values.telefono}
              onChange={handleChange}
              validacion={true}
              label="Telefono"
            />
          </div>
          <div className="py-3 text-right">
            <Button
              type="submit"
              onClick={handleSubmit}
              disabled={(isSubmitting || props.mostrar)}
              text={props.editar ? "Actualizar" : "Guardar"}
            />
          </div>
          {isSubmitting && <Spinner />}
        </div>
      )}
    </Formik>
  );
};
